import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import mainLogo from "../../images/logo.png";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Collapse,
  makeStyles,
  Grid,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  headerBar: {
    width: "100%",
  },
  drawerPaper: { width: 300, maxWidth: "85%" },
  nested: { paddingLeft: theme.spacing(4) },
  nestedDeep: { paddingLeft: theme.spacing(6) },
  logoStyle: { height: 56, objectFit: "contain" },
}));

// Mobile menu structure
const MOBILE_MENU = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about_us" },
  { label: "Pillars Of Impact", to: "/pillars_of_impact" },
  { label: "Thematic Areas", to: "/thematic_areas" },
  {
    label: "Our Projects/Programs",
    children: [
      {
        label: "Incubation and Accelerators Program",
        children: [
          { label: "Nextechczar Incubation", to: "/Nextechczar_Incubation_Program" },
          { label: "IIF Investment Readiness Program", to: "/iff_investment" },
          { label: "WIRA Program", to: "/wira" },
          { label: "GIZ/DTC Digital Transformation", to: "/giz_dtc" },
        ],
      },
      {
        label: "Market Access",
        children: [{ label: "SEADE Soft-landing Program", to: "/market_access" }],
      },
      {
        label: "AI Programs/Evaluation",
        children: [
          { label: "Intel Africa AI Community Outreach", to: "/ai_programs_evaluation" },
          { label: "Meta AI Liama 3.0 Hackathon", to: "/meta_AI_LIama" },
        ],
      },
      {
        label: "Research to Commercialization Efforts",
        children: [
          { label: "Research to Commercialization Workshop", to: "/research_to_commercialization" },
          { label: "Toolkit Validation Workshop", to: "/research_to_commerce_toolkit" },
          { label: "From Lab to Market Toolkit Development", to: "/lab_to_market" },
        ],
      },
      {
        label: "Ecosystem Partnership",
        children: [
          { label: "GIZ/DTC", to: "/partnership_giz_dtc" },
          { label: "P2C", to: "/pathway_2_scale" },
          { label: "AU-EU Dialogue", to: "/aU_EU_dialogue" },
          { label: "Innovation Fair", to: "/innovation_Fair" },
          { label: "DeepTech Summit", to: "/deepTech_Summit" },
          { label: "IIF Annual Gathering", to: "/iff_annual_gathering" },
          { label: "NIIRIC Annual Gathering", to: "/NIIRIC_second_gathering" },
        ],
      },
      {
        label: "Research and Policy Projects",
        children: [
          { label: "Raw Materials Research and Development Council", to: "/raw_materials_research" },
          { label: "Improving Crop Productivity and Climate Resilience in Nigeria", to: "/Improving_Crop_Productivity" },
          { label: " National Generative AI Policy for Inclusive Innovation", to: "/national_generative_AI" },
          { label: "Low-Resource Language Models for African Languages", to: "/AI_low_resource" },
          { label: "Data Sovereignty and Talent Sovereignty", to: "/data_Sovereignty" },
  
        ],
      },
      {
       
      },
    ],
  },
  { label: "Annual Reports", to: "/reports" },
  { label: "Blog", to: "http://blog.moolu.org/" },
  { label: "Contact Us", to: "/contact_us" },
];

// Recursive mobile menu item
function MobileMenuItem({ item, level = 0, openMap, toggleOpen, onNavigate, classes }) {
  const hasChildren = item.children && item.children.length > 0;
  const key = item.label + "|" + level;
  const isOpen = openMap[key] || false;
  const paddingClass = level === 0 ? "" : level === 1 ? classes.nested : classes.nestedDeep;

  if (hasChildren) {
    return (
      <Fragment>
        <ListItem button onClick={() => toggleOpen(key)} className={paddingClass}>
          <ListItemText primary={item.label} />
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child) => (
              <MobileMenuItem
                key={child.label + Math.random()}
                item={child}
                level={level + 1}
                openMap={openMap}
                toggleOpen={toggleOpen}
                onNavigate={onNavigate}
                classes={classes}
              />
            ))}
          </List>
        </Collapse>
      </Fragment>
    );
  }

  return (
    <ListItem
      button
      onClick={onNavigate}
      component={item.to && item.to.startsWith("http") ? "a" : Link}
      {...(item.to && item.to.startsWith("http")
        ? { href: item.to, target: "_blank", rel: "noopener noreferrer" }
        : { to: item.to || "/" })}
      className={paddingClass}
    >
      <ListItemText primary={item.label} />
    </ListItem>
  );
}

export default function HeaderBar(props) {
  const classes = useStyles();
  const [transparent, setTransparent] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openMap, setOpenMap] = useState({});

  useEffect(() => {
    const handleScroll = () => setTransparent(window.scrollY === 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleOpen = (key) => setOpenMap((prev) => ({ ...prev, [key]: !prev[key] }));
  const handleNavigate = () => setOpenDrawer(false);

  return (
    <>
      {/* DESKTOP NAV */}
      <div className="uk-visible@l">
        <div
          component={Grid}
          container
          className="headerBar"
          elevation={1}
          square
          style={{
            background: !props.fillHeader && transparent ? "transparent" : "rgba(0,0,0,0.93)",
          }}
        >
          <div className="uk-container">



        <div className="mainNavBar">
             

             <nav class="uk-navbar-container" data-uk-navbar>

             <div class="uk-navbar-left" uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                      <Link to ="/"><img src= {mainLogo} className="logoStyle"/> </Link>
                  </div>


              
                  <div class="uk-navbar-center" style={{marginLeft:"60px"}}>
                 <nav class="stroke  "   >
                        <ul class="uk-navbar-nav ">
                            

                            <li>
                              <Link to = "/about_us"> About Us </Link> 
                             
                            </li>



                            <li><Link to= "/pillars_of_impact">  Pillars Of Impact</Link></li>



                             <li>
                                <Link to="/thematic_areas">Thematic Areas </Link>
                              
                            </li>


                             
                            <li>
                                <Link to ="/events">Our Projects/Programs</Link>
                                
                                <div class="uk-navbar-dropdown">
                                    <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                      
                                    <Link to ="/emerald">  <li class="uk-active "><a href="#">Incubation and Accelerators Program</a></li> </Link>
                                           <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/Nextechczar_Incubation_Program"><li>Nextechczar Incubation</li> </Link>
                                            <Link to ="/iff_investment"><li>  IIF Investment readiness Program</li> </Link>
                                     <Link to ="/wira"> <li> Women Investment Readiness Accelerators Program (WIRA) </li></Link>
                                     <Link to ="/giz_dtc"> <li> GIZ/DTC Digital Transformation for women and Youths</li></Link>
                                
                                     
                                           </ul>
                                           </div>


                                   <Link to ="/emerald">  <li class="uk-active "><a href="#">Market Access</a></li> </Link>
                                             <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/market_access"><li>SEADE Soft-landing Market Access Program</li> </Link>
                                         
                                    
                                     
                                           </ul>
                                           </div>

                                      
                                  




                            <Link to ="">  <li class="uk-active "><a href="#">AI Programs/Evaluation</a></li> </Link>
                                                   <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/ai_programs_evaluation"><li>Intel Africa AI Community Outreach Outreach</li> </Link>
                                            <Link to ="/meta_AI_LIama"><li> Meta AI  LIama 3.0 Hackathon</li> </Link>
                                    
                                     
                                           </ul>
                                           </div>


                                    
                            <Link to ="/emerald">  <li class="uk-active "><a href="#">Research to Commercialization Efforts</a></li> </Link>
                                                   <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/research_to_commercialization"><li>Research to Commercialization Workshop</li> </Link>
                                            <Link to ="/research_to_commerce_toolkit"><li> Research to Commercialization Toolkit Validation workshop</li> </Link>
                                    
                                      <Link to ="/lab_to_market"><li> From Lab to Market R2C Toolkit Development</li> </Link>
                                    
                                           </ul>
                                           </div>




                                                     
                            <Link to ="/emerald">  <li class="uk-active "><a href="#">Ecosystem Partnership</a></li> </Link>
                                                   <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/partnership_giz_dtc"><li>GIZ/DTC</li> </Link>
                                            <Link to ="/pathway_2_scale"><li> P2C</li> </Link>
                                    
                                      <Link to ="/aU_EU_dialogue"><li> AU-EU Dialogue</li> </Link>
                                      
                                      <Link to ="/innovation_Fair"><li>Innovation Fair</li> </Link>
                                      
                                      <Link to ="/deepTech_Summit"><li> DeepTech Summit</li> </Link>
                                      
                                      <Link to ="/iff_annual_gathering"><li> IIF Annual Gathering</li> </Link>
                                      
                                      <Link to ="/NIIRIC_second_gathering"><li> NIIRIC Annual Gathering</li> </Link>
                                      
                                      <Link to ="/gitex_Nigeria"><li> GITEX Nigeria </li> </Link>


                                    
                                           </ul>
                                           </div>

                                                           
                            <Link to ="/emerald">  <li class="uk-active "><a href="#">Research and Policy Projects</a></li> </Link>
                                                   <div class="uk-navbar-dropdown">
                                             <ul class="uk-nav uk-navbar-dropdown-nav dropDown">
                                            <Link to ="/raw_materials_research"><li> Raw Materials Research and Development 
                                              Council</li> </Link>

                                               <Link to ="/Improving_Crop_Productivity"><li> Improving Crop Productivity and Climate Resilience in Nigeria</li> </Link>
                                             <Link to ="/national_generative_AI"><li> National Generative AI Policy for Inclusive Innovation (Nigeria 2025–2030)</li> </Link>

                                               <Link to ="/AI_low_resource"><li>   Low-Resource Language Models for African Languages</li> </Link>
                                                 <Link to ="/data_Sovereignty"><li>   Data Sovereignty and Talent Sovereignty</li> </Link>
                                               
                                   
                                    
                                           </ul>
                                           </div>





             
 










                                      
                                   
                                    </ul>
                                </div>
                            </li>


                         

                            <li>
                                <Link to ="/reports">Reports</Link>
                            
                            </li>


                            <li>
                                <Link to="http://blog.moolu.org/">Blog</Link>
                            
                            </li>

                            <li>
                                <Link to ="/contact_us">Contact Us</Link>
                            
                            </li>
                        </ul>
                        </nav>
                 </div> 


              <div class="uk-navbar-right ">
               
                 </div>
            </nav>






          </div>






          </div>
        </div>
      </div>




      

      {/* MOBILE NAV */}
      <div className="uk-hidden@l" style={{ padding: "12px" }}>
        <IconButton
          edge="start"
          onClick={() => setOpenDrawer(true)}
          aria-label="menu"
          style={{ zIndex: 9999, position: "relative", color: "#fff" }}
        >
          <MenuIcon />
        </IconButton>
      </div>
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
      >
        <div role="presentation">
          <List>
            {MOBILE_MENU.map((item) => (
              <MobileMenuItem
                key={item.label}
                item={item}
                level={0}
                openMap={openMap}
                toggleOpen={toggleOpen}
                onNavigate={handleNavigate}
                classes={classes}
              />
            ))}
          </List>
        </div>
      </Drawer>
    </>
  );
}
